import React, { useEffect, useState } from 'react';
import { AssetFieldProps } from '../types';
import { transformComponentsTypeToKind, customizer } from '@/common/asset-apis/getAssetModuleByRequest';
import { useAsyncEffect } from 'ahooks';
import { getModule, getField, getBizComponent } from './utils';
import { LCP_FIELD_KINDS } from '@/components/SEFieldWithModel/effects/consts';
import _ from 'lodash';
import { SPField, FormMode, FormFrom } from '@/components/SPForm';
import { Form, ConfigProvider } from 'antd';
import { FIELD_LCP_TABLE_MAP } from '@/components/SEFieldWithModel/effects/FIELD_LCP_TABLE_MAP';
import moduleMapAsset from '@/common/asset-apis/useModelMapAseet';
import useMetaStore, { useMeta } from '@/store/useMetaStore';
import useValuesStore, { useValues } from '@/store/useValuesStore';
import StoreContext from '@/store/context';
import zhCN from 'antd/es/locale/zh_CN';
import { SyncOutlined } from '@ant-design/icons';

function AssetField(props: AssetFieldProps) {
  const {
    moduleCode,
    fieldCode,
    disabled,
    isEdit,
    value,
    onChange,
    componentsCode: propsComponentsCode,
    componentsOptions: propsComponentsOptions,
    style,
  } = props;

  const [loading, setLoading] = useState<boolean>(false);
  const [field, setField] = useState<any>();
  // 此form只是为了后续业务组件内部不报错，无任何意义
  const [form] = Form.useForm<any>();
  const { transformAssetFieldType } = moduleMapAsset();

  useAsyncEffect(async () => {
    try {
      setLoading(true);
      let fieldMeta: any;
      let module: any;
      if (moduleCode && fieldCode) {
        module = await getModule(moduleCode);
        fieldMeta = await getField(module, fieldCode);
        fieldMeta.kind = transformAssetFieldType(fieldMeta.dataType);
      }

      const componentsCode = propsComponentsCode || fieldMeta?.componentsCode;
      if (componentsCode) {
        fieldMeta = fieldMeta || {};
        const component = await getBizComponent(componentsCode);
        const kind: string = (transformComponentsTypeToKind(component.components_type) as string) || LCP_FIELD_KINDS.STRING;
        const bizConfig = _.mergeWith({}, component.options, fieldMeta.options?.componentsOptions, propsComponentsOptions || {}, customizer);
        const options = _.mergeWith({}, component.options, fieldMeta.options, fieldMeta.options?.componentsOptions, propsComponentsOptions || {}, customizer);
        fieldMeta = {
          ...fieldMeta,
          kind,
          bizConfig,
          options,
        };
        // prefilter拼接
        if (!fieldMeta.bizConfig.prefilter && fieldMeta.bizConfig.filterField && fieldMeta.bizConfig.filterFieldValue) {
          fieldMeta.bizConfig.prefilter = `${fieldMeta.bizConfig.filterField} = '${fieldMeta.bizConfig.filterFieldValue}'`;
        }
      }

      if (fieldMeta) {
        const transformFn = FIELD_LCP_TABLE_MAP.get(fieldMeta.kind);
        if (transformFn) {
          const targetColumn = _.clone(fieldMeta);
          transformFn({
            field: fieldMeta,
            targetColumn,
            moduleInfo: module,
          });
          setField(targetColumn);
        } else {
          setField(fieldMeta);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  }, [moduleCode, fieldCode, propsComponentsCode, JSON.stringify(propsComponentsOptions)]);

  if (loading) {
    return <SyncOutlined spin />;
  }

  if (field) {
    return (
      <SPField
        from={FormFrom.Form}
        key={fieldCode}
        name={[fieldCode]}
        render={isEdit ? field.renderFormItem : field.render}
        form={form}
        valueType={field.valueType}
        formItemProps={field.formItemProps}
        fieldProps={field.fieldProps}
        request={field.request}
        requestParams={field.params}
        disabled={disabled}
        formValue={{ [moduleCode]: value }}
        mode={isEdit ? FormMode.Edit : FormMode.Read}
        value={value}
        onChange={onChange}
        style={style}
      />
    );
  }

  return null;
}

export default React.forwardRef((props: any, ref) => {
  const values = useValues();
  const meta = useMeta();
  return (
    <StoreContext.Provider value={{ values, meta }}>
      <ConfigProvider locale={zhCN}>
        <AssetField {...props} ref={ref} />
      </ConfigProvider>
    </StoreContext.Provider>
  );
});
